<template>
    <div class="categories">
        <div class="container">
            <div class="categories__wrapper">
                <!--                <div class="categories__wrapper__header">-->
                <!--                    <div class="categories__wrapper__header__image-wrapper &#45;&#45;pattern-lines" />-->
                <!--                </div>-->
                <Card
                    v-for="(category, index) in categories"
                    class="categories__wrapper__list"
                    :category="category"
                    :class="getClass(index)"
                    :key="'dsk-' + index + category.url"
                />
                <!--                <div class="categories__wrapper__footer">-->
                <!--                    <div class="categories__wrapper__footer__image-wrapper &#45;&#45;pattern-lines"/>-->
                <!--                    <div class="categories__wrapper__footer__image-wrapper &#45;&#45;pattern-wood-texture"/>-->
                <!--                </div>-->
            </div>
        </div>
    </div>
</template>
<script>
import VueTypes from 'vue-types';
import { CategoryShowcaseItem } from './types';

export default {
    name: 'CategoriesShowcase',
    props: {
        categories: VueTypes.arrayOf(CategoryShowcaseItem).isRequired
    },
    components: {
        Card: () => import('./components/Card')
    },
    methods: {
        getClass(index) {
            const classes = ['--first', '--second', '--third', '--for', '--five'];

            if (index >= classes.length) {
                return [];
            }

            return classes[index];
        }
    }
};
</script>

<style lang="scss">
@import './styles.scss';
</style>
